import { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import { IllustrationClosed } from '@vs-online-only-app/ui';

export const AssociateDeclinedApplicationPlaceholder: FC = () => (
  <Stack gap={2} alignItems="center">
    <IllustrationClosed />
    <Stack>
      <Typography variant="h6" align="center">
        Your account has been declined.
      </Typography>
      <Typography variant="body2" align="center">
        Sorry, we were unable to verify your account. To get it reactivated,
        please ask your manager.
      </Typography>
    </Stack>
  </Stack>
);
